import React, { useState, useEffect} from "react";
import CustomTabs from "components/tabs/customTab";
import Courses from "./Courses";

const CoursesTabs = ({ employee }) => {
    const courses = employee?.details?.courses || [];

    const [activeTab, setActiveTab] = useState(courses[0]?.course_name || "");

    useEffect(() => {
        setActiveTab(courses[0]?.course_name || "");
    }, [employee]);

    const tabOptions = courses.map(course => ({
        label: <span className="font-medium text-[12px]">{course.course_name}</span>,
        value: course.course_name
    }));

    const selectedCourse = courses.find(c => c.course_name === activeTab);

    return (
        <div className="flex flex-col gap-2 w-full">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
                height="h-10"
            />

            <div className="flex flex-col outline-none space-y-4 mt-4">
                {selectedCourse && (
                    <Courses
                        course={selectedCourse}
                        status={selectedCourse.status}
                        course_progress_percent={selectedCourse.course_progress_percent}
                        tabIndex={courses.findIndex(c => c.course_name === activeTab)}
                    />
                )}
            </div>
        </div>
    );
};

export default CoursesTabs;
